export default __webpack_public_path__ + "static/media/CheckInSplash_Willkommen.103f58a6.png";